import styled from 'styled-components';

export const GeneGridWrapper = styled.div`
    height: 200px;
    margin-bottom: 15px;
`;

export const SectionTitle = styled.h4`
    margin: 0 0 10px 0;
    font-size: 14px;
    font-weight: 600;
    color: #333;
`;
